module.exports = {
      id: "instagram-usage",
      viewBox: "0 0 18 18",
      url: "/" + "sprite-830c6fc89c6e575b53718d760c90aee8.svg#instagram",
      toString: function () {
        return this.url;
      }
    }